import * as $ from "jquery";
import * as React from "react";
import * as ReactDOM from "react-dom";
import StoreContainer from "../stores/StoreContainer";
import { PopoverInvite, PopupPositionType } from "../types";

interface PopoverInvitePortalProps {
  container: HTMLElement;
  invite: PopoverInvite;
}

class PopoverInvitePortal extends React.Component<
  PopoverInvitePortalProps,
  {}
> {
  container: HTMLDivElement;

  state = {
    loaded: false
  };

  componentDidMount() {
    this.container = document.createElement("div");
    this.container.className = "velaro-popover-invite-frame";
    this.props.container.appendChild(this.container);

    $(this.container).on("click", "[data-js=close]", () => {
      StoreContainer.InviteStore.reject();
      StoreContainer.InviteStore.closePopoverInvite();
    });

    $(this.container).on("click", "[data-js=chat]", () => {
      StoreContainer.InviteStore.accept();
      StoreContainer.InviteStore.closePopoverInvite();
      if (StoreContainer.SettingStore.isInlineDisabled()) {
        StoreContainer.FrameStore.popout();
      } else {
        StoreContainer.FrameStore.expandOrPopout();
      }
    });

    this.setState({ loaded: true }, () => {
      this.animatePopup();
    });

    if (this.props.invite.secondsToDisplay) {
      setTimeout(
        () => StoreContainer.InviteStore.closePopoverInvite(),
        this.props.invite.secondsToDisplay * 1000
      );
    }
  }

  componentWillUnmount() {
    this.props.container.removeChild(this.container);
    $(this.container).off("click");
  }

  animatePopup() {
    setTimeout(() => this.setStartPosition(), 50);
    setTimeout(() => this.setStopPosition(), 100);
  }

  setStartPosition() {
    this.container.style.top = this.getTopPosition(
      this.props.invite.animationStartPosition
    );
    this.container.style.left = this.getLeftPosition(
      this.props.invite.animationStartPosition
    );
  }

  setStopPosition() {
    this.container.style.top = this.getTopPosition(
      this.props.invite.animationStopPosition
    );
    this.container.style.left = this.getLeftPosition(
      this.props.invite.animationStopPosition
    );
  }

  getTopPosition(position: PopupPositionType) {
    switch (position) {
      case PopupPositionType.TopCenter:
      case PopupPositionType.TopLeft:
      case PopupPositionType.TopRight:
        return "0";
      case PopupPositionType.BottomCenter:
      case PopupPositionType.BottomLeft:
      case PopupPositionType.BottomRight:
        return `${window.parent.window.innerHeight -
          this.container.offsetHeight}px`;
      case PopupPositionType.Center:
      case PopupPositionType.CenterLeft:
      case PopupPositionType.CenterRight:
      default:
        return `${window.parent.window.innerHeight / 2 -
          this.container.offsetHeight / 2}px`;
    }
  }

  getLeftPosition(position: PopupPositionType) {
    switch (position) {
      case PopupPositionType.BottomLeft:
      case PopupPositionType.CenterLeft:
      case PopupPositionType.TopLeft:
        return "0";
      case PopupPositionType.BottomRight:
      case PopupPositionType.CenterRight:
      case PopupPositionType.TopRight:
        return `${window.parent.window.innerWidth -
          this.container.offsetWidth}px`;
      case PopupPositionType.BottomCenter:
      case PopupPositionType.Center:
      case PopupPositionType.TopCenter:
      default:
        return `${window.parent.window.innerWidth / 2 -
          this.container.offsetWidth / 2}px`;
    }
  }

  renderHtml() {
    return (
      <div>
        <style>{this.props.invite.css}</style>
        <div dangerouslySetInnerHTML={{ __html: this.props.invite.html }} />
      </div>
    );
  }

  render() {
    if (!this.state.loaded) {
      return null;
    }

    return ReactDOM.createPortal(this.renderHtml(), this.container);
  }
}

export default PopoverInvitePortal;
